import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "discovery-dashboard-container" */'./DiscoveryDashboardContainer').then(module => module.DiscoveryDashboardContainer);
export const AsyncDiscoveryDashboardContainer = Loadable({
  loader,
  LoadingComponent: () => null
});